<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-badge class="bg-blue">
            <i class="fa fa-file mr-2"></i>
            Change in Membership
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <FormS18MembersResolution :data="getCompanySubscribers ? getCompanySubscribers.data : null" badge="Current Membership"/>
        </b-col>
        <b-col>
          <FormS18MembersResolution :data="data" badge="New Membership"/>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import FormS18MembersResolution from "@/views/home/services/continuous-filing/task/forms/FormS18MembersResolution";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ChangeOfMembership",
  components: { FormS18MembersResolution },
  props:{
    data:Object,
    brn:String
  },
  mounted() {
    this.fetchCompanySubscribers(this.brn)
  },
  methods:{
    ...mapActions(["fetchCompanySubscribers"]),
  },
  computed:{
    ...mapGetters(["getCompanySubscribers"])
  }
};
</script>

<style scoped>
th, td{
  font-size: 12px;
}

.pdf{
  width: 100%;
  height: 800px;
  overflow-x: auto;
  border:1px solid #b1b1b1;
}
</style>